<!-- VapiEmbed.vue -->
<template>
  <div>
    <div v-if="name === 'NotFound'">
      <h3 class="h4">Convite não encontrado</h3>
      <p class="mb-0">O convite que você está tentando acessar não existe ou foi respondido.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intervoiceinished',
  components: {},
  props: {
    name: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style>
</style>
